import { render, staticRenderFns } from "./ClientContacts.vue?vue&type=template&id=218f712d&"
import script from "./ClientContacts.vue?vue&type=script&lang=js&"
export * from "./ClientContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218f712d')) {
      api.createRecord('218f712d', component.options)
    } else {
      api.reload('218f712d', component.options)
    }
    module.hot.accept("./ClientContacts.vue?vue&type=template&id=218f712d&", function () {
      api.rerender('218f712d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/ClientContacts.vue"
export default component.exports